// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginPage_loginForm__yuJvT","loginMain":"LoginPage_loginMain__fM1VF"};